import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CookieService {
  private readonly document = inject(DOCUMENT);

  read(name: string): string | null {
    const prefix = `${encodeURIComponent(name)}=`;
    const value = this.document.cookie
      .split('; ')
      .find((cookie) => cookie.startsWith(prefix));

    return value ? decodeURIComponent(value.slice(prefix.length)) : null;
  }

  write(name: string, value: string, days = 1): void {
    const expires = new Date(Date.now() + days * 86_400_000).toUTCString();
    this.document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax; Secure`;
  }

  remove(name: string): void {
    this.write(name, '', -1);
  }
}